import { render, staticRenderFns } from "./integratedCurriculum.vue?vue&type=template&id=75a246bf&scoped=true&"
import script from "./integratedCurriculum.vue?vue&type=script&lang=js&"
export * from "./integratedCurriculum.vue?vue&type=script&lang=js&"
import style0 from "./integratedCurriculum.vue?vue&type=style&index=0&id=75a246bf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a246bf",
  null
  
)

export default component.exports